<template>
  <div>
    <div class="horizontal-menu-wrapper pt-15">
      <!-- <b-nav
        tabs
        align="center"
      >
        <b-nav-item active>
          Active
        </b-nav-item>
        <b-nav-item>Inactive</b-nav-item>
        <b-nav-item disabled>
          Disabled
        </b-nav-item>
      </b-nav> -->
      <b-navbar
        type="light"
        class="header-navbar navbar-shadow align-items-center navbar-fixed p-1 justify-content-center navbar-subNav"
      >
        <b-navbar-nav>
          <b-nav-item
            to="/terms"
            :class="`${currentRouteName === 'terms' ? 'active' : ''}`"
          >
            <span class="font-weight-bolder">
              Terms
            </span>
          </b-nav-item>
          <b-nav-item
            class="active"
            to="/regulation"
            :class="`${currentRouteName === 'page-regulation' ? 'active' : ''}`"
          >
            <span class="font-weight-bolder">
              Regulation
            </span>
          </b-nav-item>
        </b-navbar-nav>
      </b-navbar>
    </div>
    <regulation />
    <div class="px-2 container">
      <footers />
    </div>
  </div>
</template>
<script>
import {
//   BNav,
  BNavItem,
  //   BNavbarBrand,
  //   BNavbarToggle,
  BNavbar,
  BNavbarNav,

//   BCollapse,
} from 'bootstrap-vue'

import regulation from '@/views/page/Regulation.vue'
import Footers from '@/views/landing/Footer.vue'

export default {
  name: 'YourMagnificentVueComponent',
  components: {
    regulation,
    // BNav,
    BNavbar,
    BNavbarNav,
    BNavItem,
    Footers,
  },
  data() {
    return {
      desc: ' ',
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },
  },
  mounted() {},
  methods: {
    goTo() {
      this.$router.push({ name: 'home' })
    },
  },
}
</script>
<style scoped lang="scss">
.navbar-subNav {
  ul {
    position: absolute;
    left: 20.5%;
    li {
        margin: 6px 7px;
        &:nth-child(1) {
            margin-left: 0;
        }
    }
    a {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
    .active::after {
        content: "";
        width: 100%;
        height: 2px;
        display: block;
        position: relative;
        bottom: -14px;
        background: #4B6AAE;
    }
  }
  @media only screen and (max-width: 830px) {
    ul {
      position: static;
    }
  }
}
.pt-15 {
    padding-top: .1rem;
}
</style>
